import Choices from 'choices.js';
import '../../../../node_modules/choices.js/public/assets/styles/choices.css';

let categoriesDisplay = 'all';

export const moduleMenus = () => {

	let menuModules = document.querySelector('.m__menus');
	if(menuModules){
        let categoriesDisplay = menuModules.querySelector('.menu').getAttribute('data-categories-display');

        initLocationsDropdown();
        mobileDietaryFilterToggle();
		menuFilter();
        toggleMenusSubcats(categoriesDisplay);
		scrollToCat();
		filterMenuType();

	}
};

export const initLocationsDropdown = () => {
    const locationsDropdown = document.getElementById('menu_location');
    const locationFilter = GetURLParameter('menu-location');
    
    if ( locationFilter ) {
        for ( let i = 0; i < locationsDropdown.length; i++ ) {
            const locationName = locationsDropdown[i].getAttribute('data-location');

            if ( locationFilter === locationName ) {
                // Set as seleted
                locationsDropdown[i].setAttribute('selected', '');

                // Load the filtered locations menu
                let loadingIcon = document.querySelector('.js-menu-loading');
                let locationId = locationsDropdown[i].value;

                menuLocation(loadingIcon, locationId);
            }
        }
    }
    
    if ( locationsDropdown ) {
        let choicesConfig = {
            itemSelectText: '',
            shouldSort: false,
            searchEnabled: false,
        };
    
        const locationChoices = new Choices(locationsDropdown, choicesConfig);
    }
}

//Copied from the ignite-menus plugin init.js file
export const GetURLParameter = (sParam) => {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) {
            return sParameterName[1];
        }
    }
}

export const mobileDietaryFilterToggle = () => {
    let dietaryFilterToggle = document.querySelector('.js-mobile-filter-toggle');

    if ( dietaryFilterToggle ) {
        dietaryFilterToggle.addEventListener('click', (e) => {
            const dietaryFilterContainer = document.querySelector('.js-dietary-filter-container');

            if ( dietaryFilterContainer ) {
                dietaryFilterContainer.classList.toggle('show');
            }
        });
    }
}

export const menuFilter = () => {

	const menuModules = document.querySelectorAll('.menu.module');
   

    if (menuModules.length) {
        menuModules.forEach((menuModule) => {

            let menuItemsContainer = menuModule.querySelector('.menu__items-container')
            let menuFilters = menuModule.querySelector('.menu__filters');
            let menuFilterPanel = menuModule.querySelector('.menu__filter-panel');
            let menuFilterOffset = menuFilters.offsetTop;
            let menuCustomHeaderOffset = menuModule.dataset.customOffset;

            let scrollTop = 0
            
            

            document.querySelectorAll('.menu-subcat').forEach(menuSubcat => {

                let menuSubcatScroll = menuSubcat.getAttribute('data-subcat-scroll');
                let menuSubcatOffset = menuSubcat.offsetTop;

                if (scrollTop > menuSubcatOffset) {

                    document.querySelectorAll('.menu__filter-menu-cats li').forEach(filterMenuCats => {
                        filterMenuCats.classList.remove('active');
                    });

                    document.querySelectorAll('[data-menu-subcat="'+menuSubcatScroll+'"]').forEach(menuSubcats => {
                        menuSubcats.classList.add('active');
                    });

                }
            });

            document.querySelectorAll('.js-open-menu-filter').forEach(openFilter => {
                openFilter.addEventListener('click', (e) => {
                    e.preventDefault(); 
                    
                    const menuFilterPanel = document.querySelector('.menu__filter-panel');
                    const body = document.querySelector('body');

                    document.querySelector('.menu__filter-panel').classList.add('is-active');
                    document.querySelector('.menu__filter-panel__overlay').classList.add('is-active');
                });
            });

            document.querySelectorAll('.js-close-menu-filter').forEach(openFilter => {
                openFilter.addEventListener('click', (e) => {
                    e.preventDefault(); 
                    
                    const menuFilterPanel = document.querySelector('.menu__filter-panel');
                    const body = document.querySelector('body');

                    document.querySelector('.menu__filter-panel').classList.remove('is-active');
                    document.querySelector('.menu__filter-panel__overlay').classList.remove('is-active');
                });
            });

            // Menu location change
     
            const menuLocationSelect = document.querySelector('#menu_location');
            
            menuLocationSelect.addEventListener('change', (event) => {

                event.preventDefault();

                let loadingIcon = document.querySelector('.js-menu-loading'),
                    locationId = event.target.value;

                menuLocation(loadingIcon, locationId);
            });


            const allergenFilters = document.querySelectorAll('input[name="allergens_filter"]');

            allergenFilters.forEach(allergenFilter => {
                allergenFilter.addEventListener('change', (event) => {

                    event.preventDefault();

                    filterMenuItemsByDietaryRequirement();
                    
                });
            });


            /* let location = GetURLParameter('location-id');

            if (location) {
                const loadingIcon = document.querySelector('.js-menu-loading');
                
                menuLocationSelect.value(location).selectric('refresh');

                menuLocation(loadingIcon, location);
            } */
        })
        
    }
}

menuFilter();

function filterMenuItemsByDietaryRequirement() {
    const allergenFilters = document.querySelectorAll('input[name="allergens_filter"]');
    
    let filterChecked = 0;

    allergenFilters.forEach(allergenFilter => {
                    
        if(allergenFilter.checked) {

            allergenFilter.parentElement.classList.add('active');

            filterChecked++;
    
            document.querySelectorAll('.menu-cat .menu-item').forEach(menuItems => {

                menuItems.classList.remove('hidden');

                if (menuItems.classList.contains(allergenFilter.value)) {
                    //menuItems.style.display = 'block';
                } else {
                    menuItems.classList.add('hidden');
                }

            });

            document.querySelectorAll('.menu-subcat').forEach(menuSubcat => {

                menuSubcat.classList.remove('hidden');

                if (menuSubcat.classList.contains(allergenFilter.value)) {
                    //menuSubcat.style.display = 'block';
                } else {
                    menuSubcat.classList.add('hidden');
                }
                
            });
        }else{
            allergenFilter.parentElement.classList.remove('active');
        }

        if(filterChecked == 0) {
            document.querySelectorAll('.menu-cat .menu-item').forEach(menuItems => {
                menuItems.classList.remove('hidden');
            });

            document.querySelectorAll('.menu-subcat').forEach(menuSubcat => {
                menuSubcat.classList.remove('hidden');
            });
        }
    });    
}


export const getOffsetTop = (element) => {
  let offsetTop = 0;
  while(element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}

export const toggleMenusSubcats = (categoriesDisplay) => {
    const triggers = document.querySelectorAll('.js-menu-filter-subcats-toggle');
    const menusContainer = document.querySelector('.js-menu-category-container');
    const filterPanel = document.querySelector('.menu__filter-panel');

    if ( triggers ) {
        triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();

                const isMobile = filterPanel.classList.contains('is-active');

                if (categoriesDisplay === 'one') {
                    if ( trigger.getAttribute('data-menu-id') === menusContainer.getAttribute('data-menu-id')  ) {
                        toggleSubcatsDisplay(trigger);
                    } else {
                        removeActiveSubcatsClass(triggers);

                        // Update menusContainer data-menu-id attribute
                        menusContainer.setAttribute('data-menu-id', trigger.getAttribute('data-menu-id'));
    
                        const loadingIcon = document.querySelector('.js-menu-category-loading');

                        // Fade out the current menu items
                        menusContainer.classList.add('fade-out');
                        
                        setTimeout(() => {
                            // Scroll back to top of new menu
                            scrollToMenuTop();
                            
                            // Show the loading icon
                            loadingIcon.classList.add('is-active');

                            //Close the popup
                            if ( isMobile ) {
                                filterPanel.classList.remove('is-active');
                                document.querySelector('.menu__filter-panel__overlay').classList.remove('is-active');
                            }
                        }, 400);

                        setTimeout(() => {
                            // Load in clicked on menu items via ajax
                            const getFetchData = () => {
                                const formData = new FormData();
                                formData.append('location_id', document.getElementById('menu_location').value);
                                formData.append('menu_id', trigger.getAttribute('data-menu-id'));
                                formData.append('action', 'create_menu_category_ajax');
                                    
                                const ajaxData = new URLSearchParams(formData);
                
                                return ajaxData;
                            }
                
                            const data = getFetchData();
                
                            fetch(window.igMenusAjaxUrl, {
                                method: 'POST',
                                credentials: 'same-origin',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    'Cache-Control': 'no-cache',
                                },
                                body: data
                            })
                            .then((response) => response.text())
                            .then((data) => {
                
                                menusContainer.innerHTML = data;
                                loadingIcon.classList.remove('is-active');
    
                                // Re-run the dietary requirements filter functionality
                                filterMenuItemsByDietaryRequirement();
    
                                // Fade In new menu items
                                menusContainer.classList.remove('fade-out');
                                
                                // Show menu sub categories when not on mobile
                                if ( !isMobile ) {
                                    if ( trigger.nextElementSibling ) {
                                        trigger.nextElementSibling.classList.add('active');
                                    }
                                }
                            })
                            .catch((error) => {
                                loadingIcon.classList.remove('is-active');
                                console.error(error);
                            });                         
                        }, 425);
    
                        // Trigger the active menu class
                        trigger.classList.add('active');
                    }
                } else {
                    toggleSubcatsDisplay(trigger);
                }
            });
        });
    }
}

function toggleSubcatsDisplay(trigger) {
    // Trigger the active menu class
    trigger.classList.toggle('active');
        
    // Show menu sub categories
    if ( trigger.nextElementSibling ) {
        trigger.nextElementSibling.classList.toggle('active');
    }
}

function removeActiveSubcatsClass(triggers) {
    triggers.forEach(trigger => {
        trigger.classList.remove('active');

        if ( trigger.nextElementSibling ) {
            trigger.nextElementSibling.classList.remove('active');

            const subCats = trigger.nextElementSibling.querySelectorAll('.menu__filter-menu-cat');

            if ( subCats ) {
                subCats.forEach(cat => {
                    cat.classList.remove('active');
                });
            }
        }
    });
}

export const scrollToCat = () => {
    const triggers = document.querySelectorAll('.js-menu-filter-subcats-toggle');
    const menuFilterCats = document.querySelectorAll('.menu__filter-menu-cats .menu__filter-menu-cat');
    const menusContainer = document.querySelector('.js-menu-category-container');
    const filterPanel = document.querySelector('.menu__filter-panel');
    
    menuFilterCats.forEach(menuFilterCat => {
        menuFilterCat.addEventListener('click', (e) => {
            e.preventDefault();
            
            const isMobile = filterPanel.classList.contains('is-active');
            const subCat = e.currentTarget.getAttribute('data-menu-subcat');

			menuFilterCats.forEach(filterCats => {
				filterCats.classList.remove('active');
			});

			e.currentTarget.classList.add('active');
        
            // If on mobile check if menu needs to be loaded in first
            if ( isMobile ) {
                const menuID = menuFilterCat.getAttribute('data-menu-id');

                if ( menuID != menusContainer.getAttribute('data-menu-id') ) {
                    removeActiveSubcatsClass(triggers);

                    const trigger = document.querySelector('.js-menu-filter-subcats-toggle[data-menu-id="'+menuID+'"]');
                    toggleSubcatsDisplay(trigger);

                    // Update menusContainer data-menu-id attribute
                    menusContainer.setAttribute('data-menu-id', menuID);

                    const loadingIcon = document.querySelector('.js-menu-category-loading');

                    // Fade out the current menu items
                    menusContainer.classList.add('fade-out');
                    
                    // Show the loading icon
                    loadingIcon.classList.add('is-active');

                    setTimeout(() => {        
                        //Close the popup
                        filterPanel.classList.remove('is-active');
                        document.querySelector('.menu__filter-panel__overlay').classList.remove('is-active');
                    }, 400);

                    setTimeout(() => {
                        // Load in clicked on menu items via ajax
                        const getFetchData = () => {
                            const formData = new FormData();
                            formData.append('location_id', document.getElementById('menu_location').value);
                            formData.append('menu_id', menuID);
                            formData.append('action', 'create_menu_category_ajax');
                                
                            const ajaxData = new URLSearchParams(formData);
            
                            return ajaxData;
                        }
            
                        const data = getFetchData();
            
                        fetch(window.igMenusAjaxUrl, {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'Cache-Control': 'no-cache',
                            },
                            body: data
                        })
                        .then((response) => response.text())
                        .then((data) => {
                            menusContainer.innerHTML = data;
                            loadingIcon.classList.remove('is-active');

                            // Re-run the dietary requirements filter functionality
                            filterMenuItemsByDietaryRequirement();

                            // Fade In new menu items
                            menusContainer.classList.remove('fade-out');
                        }).then((data) => {                        
                            window.scrollTo({top: getSubcatTopPos(subCat), behavior: 'smooth'});
                        })
                        .catch((error) => {
                            loadingIcon.classList.remove('is-active');
                            console.error(error);
                        });                         
                    }, 425);              
                } else {
                    filterPanel.classList.remove('is-active');
                    document.querySelector('.menu__filter-panel__overlay').classList.remove('is-active');

                    window.scrollTo({top: getSubcatTopPos(subCat), behavior: 'smooth'});
                }
            } else {
                window.scrollTo({top: getSubcatTopPos(subCat), behavior: 'smooth'});
            }
		});
	});
}

function getSubcatTopPos(subCat) {
    const menuFilters = document.querySelector('.menu__filters');
    let menuFiltersStyles = window.getComputedStyle(menuFilters);
    let menuFiltersmargin = parseFloat(menuFiltersStyles['marginTop']) + parseFloat(menuFiltersStyles['marginBottom']);
    let menuFiltersHeight = Math.ceil(menuFilters.offsetHeight + menuFiltersmargin);

    const subCatItems = document.querySelector('[data-subcat-scroll="'+subCat+'"]');
    const subCatItemsOffset = getOffsetTop(subCatItems) - menuFiltersHeight - 75;

    return subCatItemsOffset;
}

scrollToCat();

export const scrollToMenuTop = () => {

    const menuFilters = document.querySelector('.menu__filters');
            
    let menuFiltersStyles = window.getComputedStyle(menuFilters);
    let menuFiltersmargin = parseFloat(menuFiltersStyles['marginTop']) + parseFloat(menuFiltersStyles['marginBottom']);
    let menuFiltersHeight = Math.ceil(menuFilters.offsetHeight + menuFiltersmargin);
    let headerHeight = Math.ceil(document.querySelector('.header').offsetHeight);
    menuFiltersHeight = menuFiltersHeight + headerHeight;

    const menuItems = document.querySelector('.menu__items');
    const menuItemsOffset = menuItems.getBoundingClientRect().top + window.scrollY;
    const scrollToMenu = menuItemsOffset - menuFiltersHeight;

    window.scrollTo({top: scrollToMenu, behavior: 'instant'});
}

export const filterMenuType = () => {

    const menuFilterOptions = document.querySelectorAll('.menu__filter-panel .js-menu-filter-option');

    let loadingIcon = document.querySelector('.js-menu-loading');

    menuFilterOptions.forEach(menuFilterOption => {
        menuFilterOption.addEventListener('click', (e) => {

            const filterPanel = document.querySelector('.menu__filter-panel');
            if(filterPanel.classList.contains('is-active')) {
                filterPanel.classList.remove('is-active');
                document.querySelector('.menu__filter-panel__overlay').classList.remove('is-active');
            }

            const menuFilterOptionsActive = document.querySelectorAll('.menu__filter-panel .js-menu-filter-option.active');

            menuFilterOptionsActive.forEach(filterOption => {
                
                filterOption.classList.remove('active');

                let filterContainerClose = document.getElementById(filterOption.dataset.container);

                filterContainerClose.style.height = '0px';

                setTimeout(function () {
                    filterContainerClose.classList.remove('active');
                }, 500);
            });

            e.currentTarget.classList.add('active');

            let filterContainer = document.getElementById(e.currentTarget.dataset.container);

            filterContainer.classList.add('active');
            filterContainer.style.height = 'auto';

            let height = filterContainer.clientHeight + 'px';

            filterContainer.style.height = height;
            filterContainer.style.height = '0px';
            
            setTimeout(function () {
                filterContainer.style.height = height;
            }, 0);
    
            const container = document.querySelector('.js-menu-category-container'),
                  loadingIcon = document.querySelector('.js-menu-category-loading'),
                  menuCatTitle = event.currentTarget.getAttribute('data-menu-cat');

            const getFetchData = () => {
                const formData = new FormData();
                formData.append('location_id', document.getElementById('menu_location').value);
                formData.append('menu_id', container.getAttribute('data-menu-id'));
                formData.append('cat_title', menuCatTitle);
                formData.append('action', 'create_menu_category_ajax');
                    
                const ajaxData = new URLSearchParams(formData);

                return ajaxData;
            }

            const data = getFetchData();

            fetch(window.igMenusAjaxUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: data
            })
            .then((response) => response.text())
            .then((data) => {

                container.innerHTML = data;
                loadingIcon.classList.remove('is-active');

                scrollToMenuTop();

            })
            .catch((error) => {
                loadingIcon.classList.remove('is-active');
                console.error(error);
            });  
        });
    });
}

filterMenuType();

export const menuLocation = (loadingIcon, locationId) => {
    const categoriesDisplay = document.querySelector('.m__menus .menu').getAttribute('data-categories-display');

    const filterFormData = new FormData();
    filterFormData.append('id', locationId);
    filterFormData.append('categories_display', categoriesDisplay);
    filterFormData.append('action', 'get_menu_filters');

    const filterData = new URLSearchParams(filterFormData);

    const filterPanelcontainer = document.querySelector('.menu__filter-panel .menu__filter-menu-cats'); 

    loadingIcon.classList.add('is-active')
    document.querySelector('.js-menu-items-container').classList.add('loading');

    fetch(window.igMenusAjaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: filterData
    })
    .then((response) => response.text())
    .then((data) => {

        filterPanelcontainer.innerHTML = data;

        scrollToCat();
        filterMenuType();
        toggleMenusSubcats(categoriesDisplay);
    
    })
    .catch((error) => {
    	loadingIcon.classList.remove('is-active');
        document.querySelector('.js-menu-items-container').classList.remove('loading');
        console.error(error);
    });  

    // Then gather menu data

    const menuFormData = new FormData();
    menuFormData.append('id', locationId);
    menuFormData.append('categories_display', categoriesDisplay);
    menuFormData.append('action', 'get_menu_items');

    const menuData = new URLSearchParams(menuFormData);
    const menuCategorycontainer = document.querySelector('.js-menu-category-container');      

    fetch(window.igMenusAjaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: menuData
    })
    .then((response) => response.text())
    .then((data) => {

        menuCategorycontainer.innerHTML = data;

        // Update container data-menu-id attribute with the first menu id so that the ajax works properly after a new menu has been loaded in
        const newFirstMenuID = document.querySelector('.js-menu-filter-subcats-toggle').getAttribute('data-menu-id');
        menuCategorycontainer.setAttribute('data-menu-id', newFirstMenuID);

        loadingIcon.classList.remove('is-active');
        document.querySelector('.js-menu-items-container').classList.remove('loading');

        scrollToMenuTop();
    
    })
    .catch((error) => {
        loadingIcon.classList.remove('is-active');
        document.querySelector('.js-menu-items-container').classList.remove('loading');
        console.error(error);
    });  
}